import React from 'react';
import { BreadcrumbWrapperReimagine } from '../../components/common/breadcrumb-wrapper-reimagine/breadcrumb-wrapper-reimagine';
import { ViewTemplate } from '../../components/sections';
import { DiagnosticsDetails } from '../../components/sections/vehicle-health/components/diagnostics/diagnostics-details';
import { useVehicleHealthPageComponents } from '../../components/sections/vehicle-health/components/vehicle-health-page-components';
import { useDiagnosticsDetailsContent } from '../../components/sections/vehicle-health/hook/use-diagnostics-details-content';
import { useLocation } from 'react-router-dom';

interface BreadCrumbProps {
    vehicleHealthComponent: any;
    currentRoute: string;
}

const VhaAlertBreadCrumb = (props: BreadCrumbProps) => {
    const vhaUrl = props.currentRoute.endsWith('/')
        ? props.currentRoute.substring(0, props.currentRoute.length - 1)
        : props.currentRoute;
    const vhaLink = vhaUrl.substring(0, vhaUrl.lastIndexOf('/'));

    const handleClick = () => {
        window.location.href = vhaLink;
    };
    return (
        <>
            <span
                className="breadcrumb-link-ellipses-expanded"
                onClick={handleClick}
            >
                <span>{props.vehicleHealthComponent?.vehicleHealthTitle}</span>
            </span>
            <span className="back-slash">{'/'}</span>
        </>
    );
};

export const DiagnosticsDetailsView = () => {
    const currentRoute = window.location.pathname;
    const categoryId = new URLSearchParams(useLocation().search)?.get(
        'categoryId'
    );
    const getCategoryName = () => {
        if (categoryId === '0') {
            return 'powertrain';
        } else if (categoryId === '1') {
            return 'brakesAndSuspension';
        } else if (categoryId === '2') {
            return 'fluidsAndFilters';
        } else if (categoryId === '3') {
            return 'restraintsAndDriverAssistance';
        }
        return '';
    };
    const diagnsticsContent = useDiagnosticsDetailsContent(getCategoryName());
    const [vehicleHealthComponent] = useVehicleHealthPageComponents();

    return (
        <>
            {diagnsticsContent && (
                <ViewTemplate page={'PowerTrain Details'}>
                    <BreadcrumbWrapperReimagine
                        currentPage={
                            diagnsticsContent.diagnosticsDetails
                                .diagnosticsDetailsBreadcrum
                        }
                        hashId="support"
                        title={
                            <VhaAlertBreadCrumb
                                vehicleHealthComponent={vehicleHealthComponent}
                                currentRoute={currentRoute}
                            />
                        }
                    />
                    <DiagnosticsDetails
                        content={diagnsticsContent}
                        categoryId={categoryId}
                    />
                </ViewTemplate>
            )}
        </>
    );
};

export default DiagnosticsDetailsView;
